import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const AlertCircle = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 3C7.0294 3 3 7.0292 3 12C3 16.9708 7.0294 21 12 21C16.9706 21 21 16.9708 21 12C21 7.0292 16.9706 3 12 3ZM12 17.8906C11.277 17.8906 10.691 17.3046 10.691 16.5816C10.691 15.8586 11.277 15.2726 12 15.2726C12.723 15.2726 13.3092 15.8586 13.3092 16.5816C13.3092 17.3046 12.723 17.8906 12 17.8906ZM12.9162 13.7016L13.421 7.7718C13.4324 7.6992 13.44 7.6252 13.44 7.549C13.44 6.7538 12.7954 6.1092 12 6.1092C11.205 6.1092 10.56 6.7538 10.56 7.549C10.56 7.6252 10.5678 7.6992 10.579 7.7718L11.0836 13.7016C11.0836 14.2076 11.494 14.6178 12 14.6178C12.506 14.6178 12.9162 14.2076 12.9162 13.7016Z"
            fill={color}
        />
    </StarryUIIcon>
);
